// src/hooks/useTypedTitleOnce.js
import { useEffect, useRef, useState } from "react";

export default function useTypedTitleOnce(title, { shouldType, onceKey }) {
  const typedOnceRef = useRef(new Set());
  
  const [typed, setTyped] = useState(shouldType ? "" : title);

  useEffect(() => {
    if (!shouldType || (onceKey && typedOnceRef.current.has(onceKey))) {
      setTyped(title);
      return;
    }
    let i = 0;
    setTyped("");
    const start = setTimeout(() => {
      const id = setInterval(() => {
        i += 1;
        setTyped(title.slice(0, i));
        if (i >= title.length) {
          clearInterval(id);
          if (onceKey) typedOnceRef.current.add(onceKey);
        }
      }, 50);
    }, 150);
    return () => clearTimeout(start);
  }, [title, shouldType, onceKey]);

  return typed;
}
